import { PaymentPageV2 } from './PaymentPageV2';

export function PPRAPaymentPageWrapper() {
  return <PaymentPageV2 />;
}

export default PPRAPaymentPageWrapper;
